import React from 'react'

const defaultTipPercentage = 10;
let customTipValue;

class TipSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            customTipError:false,
            showCustomTipInput: false,
            customTipValue:''
        };
        this.onChangeCustomTip = this.onChangeCustomTip.bind(this);
        this.onChangeCustomTipInput = this.onChangeCustomTipInput.bind(this);
        this.showCustomTipInput = this.showCustomTipInput.bind(this);
    }

    onChangeCustomTipInput(event) {
        if(isNaN(event.target.value) || event.target.value < 0) {
            return;
        }
        this.setState({customTipValue:event.target.value});
    }
    
    onChangeCustomTip() {
        const {onChangeCustomValue} = this.props;
        const customValue = this.state.customTipValue || 0
        onChangeCustomValue(customValue)
        this.setState({showCustomTipInput:false})
    }
    
    showCustomTipInput() {
        
        if(!this.state.showCustomTipInput) {
            const {onChangePercent} = this.props;
            this.setState({showCustomTipInput:true, customTipValue:''});
            onChangePercent(-1);
        }
    }

    onChangePercentOption (percent) {
        const {onChangePercent} = this.props;
        this.setState({showCustomTipInput:false});
        onChangePercent(percent);
    }

    render () {
        const {percent} = this.props;
        return (
            <div className="tip-selector">
                <div className="tip-options-container">
                    <div className={percent == 10 ? 'tip-option active':'tip-option'} onClick={() => {this.onChangePercentOption(10)}}>
                        <span className="tip-value">10%</span>
                    </div>
                    <div className={percent == 15 ? 'tip-option active':'tip-option'} onClick={() => {this.onChangePercentOption(15)}}>
                        <span className="tip-value">15%</span>
                    </div>
                    <div className={percent == 20 ? 'tip-option active':'tip-option'} onClick={() => {this.onChangePercentOption(20)}}>
                        <span className="tip-value">20%</span>
                    </div>
                    <div className={percent == 0 ? 'tip-option active':'tip-option'} onClick={() => {this.onChangePercentOption(0)}}>
                        <span className="tip-value">No tip</span>
                    </div>
                    <div className={percent == -1 ? 'tip-option active':'tip-option'} onClick={this.showCustomTipInput}>
                        <span className="tip-value">Custom</span>
                    </div>
                </div>
                <div className={this.state.showCustomTipInput?"tip-custom":"tip-custom hidden"}>
                    <div className="input-group">
                        <span className="input-group-addon">$</span>
                        <input type="number" className="form-control" min="0" aria-label="Custom Tip Amount" placeholder="Custom Tip Amount" value={this.state.customTipValue} onChange={this.onChangeCustomTipInput} />
                        <span className="input-group-btn">
                            <button className="btn btn-default" type="button" onClick={this.onChangeCustomTip}>OK</button>
                        </span>
                    </div>
                </div>
            </div>
        )
    }
    
}



export default TipSelector;



// WEBPACK FOOTER //
// ./src/components/commons/tip-selector/TipSelector.js